var map = {
	"./Cookies": [
		28913,
		913
	],
	"./Cookies/": [
		28913,
		913
	],
	"./Cookies/index": [
		28913,
		913
	],
	"./Cookies/index.tsx": [
		28913,
		913
	],
	"./Home": [
		94925,
		966,
		996
	],
	"./Home/": [
		94925,
		966,
		996
	],
	"./Home/index": [
		94925,
		966,
		996
	],
	"./Home/index.tsx": [
		94925,
		966,
		996
	],
	"./Privacy": [
		62772,
		772
	],
	"./Privacy/": [
		62772,
		772
	],
	"./Privacy/index": [
		62772,
		772
	],
	"./Privacy/index.tsx": [
		62772,
		772
	],
	"./Staking": [
		99363,
		363
	],
	"./Staking/": [
		99363,
		363
	],
	"./Staking/index": [
		99363,
		363
	],
	"./Staking/index.tsx": [
		99363,
		363
	],
	"./Terms": [
		43578,
		578
	],
	"./Terms/": [
		43578,
		578
	],
	"./Terms/index": [
		43578,
		578
	],
	"./Terms/index.tsx": [
		43578,
		578
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70717;
module.exports = webpackAsyncContext;